import exhibitors from './exhibitors/de';
import visitors from './visitors/de';
import managers from './managers/de';

export default {
  exhibitors,
  visitors,
  managers,
};
